import { zarazService } from "@/services";
import { ZarazEcommerceProduct } from "@c2s-npm/zaraz-utils";
import { useEffect } from 'react';
import { useAppDispatch } from '@/store';
import { setCartItems } from '../../../actions/cart.actions';
import Big from 'big.js';
import parseJson from '@utils/parseJson';

type Props = {
  cartItems?: string;
  cartSummary?: string;
  promoItems?: string;
  removedOutOfStockItems?: string;
  potentialPromoCode?: string;
  potentialFreeGift?: string;
};

const useCartData = ({
  cartItems,
  cartSummary,
  promoItems,
  removedOutOfStockItems,
  potentialPromoCode,
  potentialFreeGift,
}: Props) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const items = parseJson(cartItems);
    dispatch(
      setCartItems({
        items,
        summary: parseJson(cartSummary),
        relatedItems: parseJson(promoItems),
        removedOutOfStockItems: parseInt(removedOutOfStockItems),
        potentialPromoCode: parseJson(potentialPromoCode),
        potentialFreeGift: parseJson(potentialFreeGift),
      })
    );

    console.log({
      cartItems,
      cartSummary,
      promoItems,
      removedOutOfStockItems,
      potentialPromoCode,
      potentialFreeGift,
    })
    trackCartViewed(items);
  }, [cartItems, cartSummary, promoItems, removedOutOfStockItems, potentialPromoCode, potentialFreeGift]);
};

export default useCartData;

const trackCartViewed = (items: any[]) => {
  zarazService.ecommerce.cartViewed({
    products: items.map<ZarazEcommerceProduct>(i => ({
      product_id: i.id.toString(),
      sku: i.upc,
      category: i.categoryName,
      name: i.displayName,
      brand: 'RTIC Outdoors',
      price: i.rate,
      currency: 'usd',
      quantity: i.quantity,

      url: new URL(i.url, window.location.origin).toString(),
      imageUrl: i.webImages.default.zoomed.url,
      comparePrice: i.baseRate,
    })),
    currency: 'usd',
    total: items.reduce((total: Big, i: any) => total.plus(i.rateQuantity), Big(0)).toNumber()
  })
}
